import Vue from 'vue'
import Router from 'vue-router'

import Accueil from '@/components/Accueil'
import Visite from '@/components/Visite'
import Reservation from '@/components/Reservation'
import Histoire from '@/components/Histoire'


Vue.use(Router)

export default new Router({
    routes: [
        { path: '/',                name: 'Accueil',        component: Accueil } ,
        { path: '/visite',          name: 'Visite',         component: Visite } ,
        { path: '/reservation',     name: 'Reservation',    component: Reservation } ,
        { path: '/histoire',                      name: 'Histoire',                       component: Histoire } ,
        
    ]
})





// WEBPACK FOOTER //
// ./src/router/index.js